//core
import React from 'react';
import { makeStyles } from '@material-ui/core';
//material-ui
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
//dashboard-pro
import Button from "components/CustomButtons/Button.jsx";
//component
// import PerfectScrollbar from "perfect-scrollbar";
//css
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const confirmModalStyle = makeStyles(theme => (modalStyle));

function ProtocolModal(props) {
    const classes = confirmModalStyle();

    // useEffect(() => {
    //     let ps = new PerfectScrollbar('#protocol-modal-slide', {
    //         suppressScrollX: true,
    //         suppressScrollY: false
    //     });    
    // }, [])

    return (
        <Dialog classes={{root:classes.center,paper:classes.modal}} 
            open={props.open} 
            transition={Transition}
            maxWidth='md'
            fullWidth={true}
            keepMounted
            onClose={props.close}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">
            <DialogTitle id="classic-modal-slide-title"
                disableTypography
                className={classes.modalHeader}>
                <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    color="transparent"
                    onClick={props.close}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>认证协议</h4>
            </DialogTitle>
            <DialogContent style={{overflow:'auto'}} id="protocol-modal-slide" className={classes.modalBody}>
                <div dangerouslySetInnerHTML={{__html:props.content}}></div>
            </DialogContent>
            <DialogActions className={classes.modalFooter +" " +classes.modalFooterCenter}>
                <div>
                    <Button onClick={props.close}>关闭</Button>
                    {props.curId ? (<Button onClick={props.confirm} color="success">确定</Button>) : ('')}
                </div>
            </DialogActions>
        </Dialog>
    )    
}

export default ProtocolModal;